module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/excel-766f5a8553f78a58f5f6e6cceeb73814.svg";